import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import StudioHeading from '../../../StudioHeading';
import BaseHeader from '../BaseHeader';
import DiscountTabs from './DiscountTabs';
import CreateDiscountButton from './CreateDiscountButton';

interface Props {
  className?: string;
}

const SellerDiscountsHeader: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isDiscountsChangesEnabled = useFlag('studio_discounts_changes');

  return (
    <BaseHeader
      className={className}
      titleSlot={
        <>
          <StudioHeading>{t('studio.header.tabs.discounts')}</StudioHeading>
          {!isDiscountsChangesEnabled && <DiscountTabs />}
        </>
      }
      actions={!isDiscountsChangesEnabled && <CreateDiscountButton />}
    />
  );
};

SellerDiscountsHeader.displayName = 'SellerDiscountsHeader';

export default SellerDiscountsHeader;
